import type { PropsWithChildren } from "react";

interface FieldWrapperProps {
  title: string;
}

export const FieldWrapper = ({
  title,
  children,
}: PropsWithChildren<FieldWrapperProps>) => (
  <>
    <label htmlFor="cover-image" className="mb-2">
      {title}
    </label>
    <div className="relative mb-2 flex flex-row items-start justify-between whitespace-pre-wrap">
      {children}
    </div>
  </>
);
